export default class AssociatedFileModel {

  id: string;
  fileName: string;
  fileSize: number;
  comments: string | null;

  constructor(serverModel: any) {
    this.id = serverModel.id;
    this.fileName = serverModel.originalFileName;
    this.fileSize = serverModel.fileSize;
    this.comments = serverModel.comments ?? null;
  }
}
